export const routesAuth = {
  login: '/login',
};
